import { Component, ElementRef, HostListener, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { interval, Subject } from 'rxjs';
//import { FormArray, FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../services/api.service';
import { CommonService } from '../../../services/common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';


@Component({
    selector: 'app-display-errorlog',
    templateUrl: './display-errorlog.component.html',
    styleUrls: ['./display-errorlog.component.scss']
})
export class DisplayErrorLogComponent implements OnInit {
    dtOptions: DataTables.Settings = {
        order: [[1, 'desc']]
    };

    @ViewChild(DataTableDirective, { static: false }) datatableElement: DataTableDirective;
    getErrorDetails: any;
    dtTrigger = new Subject();
    //reactiveFormName: FormGroup;
    emiratesList: any = [];
    addComapanyMappingResponseData: any = [];
    listOfTransactions: any = [];
    companyList: any = [];
    userLoginDetails: any = {};
    selectedCompanyInfo: any = {};
    selectedLang: string = "";
    amount: string = "";
    filterSearchBox: any;
    filterStartDate: any;
    filterEndDate: any;
    noRecordsFound: boolean = false;
    isSubmitted: Boolean = false;
    addtionalCustomersArray = [];
    displayAddtionalCustomersArray = [];
    EIDCardData: any;
    modItems: any;
    nationalist: any = [];
    customerIdArray = [];
    userLogin: any;
    username: any;
    userLoginData: any;
    firstName: any;
    lastName: any;
    emailId: any;
    mobileNumber: any;
    emiratesId: any;
    passportNumber: any;
    nation: any;
    isviewDetailsClicked = false;
    patchAddtionalCustomersData = [];
    constructor(
        private router: Router,
        private apiCall: ApiService,
        public common: CommonService,
        private translate: TranslateService,
        //private formBuilder: FormBuilder,
        private modalService: NgbModal,
        private spinner: NgxSpinnerService,
    ) { }

    async ngOnInit() {
        // const body = document.getElementsByTagName('body')[0];
        // body.classList.remove('userLogin');
        // this.dtOptions = {
        //     order: [[0, 'desc']],
        //     language: ({
        //         "zeroRecords": await this.translate.get('NoDataAvailable').toPromise(),
        //         "search": await this.translate.get('Search').toPromise(),
        //         "info": await this.translate.get('Information').toPromise(),
        //         "infoFiltered": await this.translate.get('infoFiltered').toPromise(),
        //         "infoEmpty": await this.translate.get('infoEmpty').toPromise(),
        //         "lengthMenu": await this.translate.get('lengthMenu').toPromise(),
        //         "paginate": {
        //             "first": await this.translate.get('First').toPromise(),
        //             "last": await this.translate.get('Last').toPromise(),
        //             "next": await this.translate.get('Next').toPromise(),
        //             "previous": await this.translate.get('Previous').toPromise(),
        //         }
        //     }),
        // }

        this.getErrorDetails = JSON.parse(this.common.getValueFromSessionStorage("ErrorLog"));
    }


    closeAction() {
        this.common.closeTimer();
        if (this.modalService.hasOpenModals) {
            this.modalService.dismissAll();
        }
    }
    viewErrorDetails(){
        this.isviewDetailsClicked = true;
    }
}

